<template>
  <van-empty image="error" description="404" />
</template>

<script>

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'page404',
  computed: {
    message() {
      return 'The webmaster said that you can not enter this page...'
    }
  }
}
</script>

<style>
  .custom-image .van-empty__image {
    width: 90px;
    height: 90px;
  }
</style>